<template>
  <v-card
      flat
      class="mx-auto"
      max-width="800"
      mim-width="350"
  >
    <v-card class="mt-2" rounded="0" flat>
      <v-card-text class="pb-2 text-body-1 font-weight-bold">티켓 구매</v-card-text>
      <v-carousel
          v-model="model"
          cycle
          height="130"
          hide-delimiter-background
          color="primary"
          :show-arrows="false">
        <v-carousel-item
            eager
            v-for="item in items"
            :src="getRealImgPath(item.src)"
            @click="$router.push('/upjang?tab=40')"
            cover>
        </v-carousel-item>
      </v-carousel>
    </v-card>

    <v-card v-if="isAuth && tickets.length > 0" flat>
      <v-card-text class="pb-2 text-body-1 font-weight-bold">보유 티켓/쿠폰</v-card-text>
      <div class="ma-2">
        <v-row dense>
          <v-col
              v-for="ticket in tickets"
              cols="12"
          >
            <v-card
                :style="'border: 1px solid #BDBDBD'"
                class="rounded-lg"
                variant="outlined"
                :disabled="ticket.used_yn !== 'N'"
                @click="toToTicketDetail(ticket.tktorgno)">
              <div class="d-flex flex-no-wrap ">
                <div class="pa-2">
                  <v-card-text class="pa-0 font-weight-bold text-subtitle-2">
                    {{ticket.tk_name}}
                    <v-chip
                        v-if="ticket.used_yn === 'Y'"
                        class="ma-0 mb-1"
                        color="grey-darken-3"
                        text-color="white"
                        size="x-small"
                    >
                      사용완료
                    </v-chip>
                    <v-chip
                        v-if="ticket.used_yn === 'E'"
                        class="ma-0 mb-1"
                        color="red"
                        text-color="white"
                        size="x-small"
                    >
                      유효기간 만료
                    </v-chip>
                  </v-card-text>
                  <v-card-text class="pa-0 pt-1 text-body-2">{{ticket.msg1}} ({{ ticket.tktorgno }})</v-card-text>
                  <v-card-text class="pa-0 pt-1 text-body-2">유효기간: {{ticket.validfrom_text}} - {{ticket.validto_text}}</v-card-text>
                </div>
              </div>

            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-card>

    <v-card v-else-if="isAuth && tickets.length < 1" flat>
      <v-card-text class="pb-2 text-body-1 font-weight-bold">보유 티켓/쿠폰</v-card-text>
      <v-card-text class="mt-4 text-body-1 text-center">보유한 티켓/쿠폰이 없습니다.</v-card-text>
    </v-card>

    <v-card v-else flat>
      <v-card-text class="pb-2 text-body-1 font-weight-bold">보유 티켓/쿠폰</v-card-text>
      <v-card-text class="mt-4 text-body-1 text-center">간편인증이 필요한 정보입니다.</v-card-text>
      <v-card-text class="pt-0 text-center">
        <v-btn color="primary" to="/login" variant="tonal">간편인증</v-btn>
      </v-card-text>
    </v-card>
  </v-card>

  <MobileFooter></MobileFooter>

</template>

<script>
import MobileFooter from "@/components/common/MobileFooter";
import {main, ticket} from "@/api";
import authStore from "@/store/auth";
import commonStore from "@/store/common";
import QrcodeVue from "qrcode.vue";

export default {
  name: "Ticket",
  components: {MobileFooter, QrcodeVue},
  data() {
    return {
      items: [],
      tickets: [],
      isAuth: false,
      timer: null,
      timerStr: '',
      model: 0,
    }
  },
  created() {
    this.isAuth = authStore.state.authInfo.token !== null
    this.getBannerList(commonStore.state.common.corpCode)
    this.getHavingTicketList()
  },
  computed: {
    isAuth() {
      return authStore.state.authInfo.token !== null
    },
  },
  methods: {
    getBannerList() {
      main.getNoticeList(commonStore.state.common.corpCode, 'ticket_banner')
          .then(data => {
            console.log(data)
            if (data.data.notices) {
              let array
              if (data.data.notices.length > 3) {
                array = data.data.notices.slice(0, 3)
              } else {
                array = data.data.notices
              }

              array.forEach((item) => {
                this.items.push({
                  src: item.thumb_url
                })
              })
            }
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    getHavingTicketList() {
      if (!this.isAuth) {
        return
      }

      ticket.getHavingTicketList(
          commonStore.state.common.corp,
          commonStore.state.common.brch
      )
          .then(data => {
            console.log(data)
            this.tickets = data.data.tickets
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    toToTicketDetail(tktorgno) {
      this.$router.push('/ticket/' + tktorgno)
    }
  }
}
</script>

<style scoped>

</style>